import React from "react";
import {useTranslation} from "react-i18next";
import Header from "./Header";
import {CircularProgress} from "@nextui-org/react";
import PoweredBy from "./PoweredBy";

function Loading({label, minimal = false}) {
  const {t} = useTranslation();

  // `minimal` drops the Urtentic header/footer branding — used while the
  // app's own initial fetch (branding + auth) is still in flight, so a
  // customer's themed embed doesn't flash Urtentic's default logo/wordmark
  // before their own branding has loaded.
  return (
      <div data-testid="loading-screen" className="flex flex-col w-full h-full justify-between">
          {minimal ? <div/> : <Header closeEnabled={false}/>}
          <div className="flex flex-col items-center mb-10">
              <CircularProgress
                  size="lg"
                  label={label || t("common.loading.defaultLabel")}
                  classNames={{ label: "text-[color:var(--urtentic-sdk-body,#737373)]" }}
              />
          </div>
          <div className="flex flex-row justify-center p-4">
              {!minimal && <PoweredBy/>}
          </div>
      </div>
  );
}

export default Loading;
